// extracted by mini-css-extract-plugin
export default {"graph-wrapper":"OIVcTHFXyzEBcDdg58cU","graph-controlls":"gUNcgTRz33qFWHAEbeCz"};